/**
 * Searching the rotation history (pure).
 *
 * A run is not itself named, so the term is matched against the ELEMENTS it
 * touched: "what happened to Greenluck Sin" is the only question anyone asks
 * of this list. Matching runs are kept whole rather than having their diffs
 * pruned — a run that shows only the row you searched for would misrepresent
 * what it did, and the before → after story is the point of the record.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { RotationRunRecord } from '@trafficpulse/shared';

function runMatches(run: RotationRunRecord, needle: string): boolean {
  return run.diffs.some((d) =>
    [d.itemName, d.itemId, d.poolName, d.reason].some((v) =>
      v?.toLowerCase().includes(needle),
    ),
  );
}

/** Runs touching an element that matches `search` (blank passes everything). */
export function filterRunsBySearch(
  runs: RotationRunRecord[],
  search: string,
): RotationRunRecord[] {
  const needle = search.trim().toLowerCase();
  if (!needle) return runs;
  return runs.filter((run) => runMatches(run, needle));
}
